/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: mrz document side wasn't provided
 * @export
 * @interface PaxCheckNoMrzSideScannedError
 */
export interface PaxCheckNoMrzSideScannedError {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckNoMrzSideScannedError
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckNoMrzSideScannedError interface.
 */
export function instanceOfPaxCheckNoMrzSideScannedError(value: object): value is PaxCheckNoMrzSideScannedError {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckNoMrzSideScannedErrorFromJSON(json: any): PaxCheckNoMrzSideScannedError {
    return PaxCheckNoMrzSideScannedErrorFromJSONTyped(json, false);
}

export function PaxCheckNoMrzSideScannedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckNoMrzSideScannedError {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckNoMrzSideScannedErrorToJSON(json: any): PaxCheckNoMrzSideScannedError {
    return PaxCheckNoMrzSideScannedErrorToJSONTyped(json, false);
}

export function PaxCheckNoMrzSideScannedErrorToJSONTyped(value?: PaxCheckNoMrzSideScannedError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

